(function () {
  const root = document.querySelector('[data-powdi-article]');
  if (!root) return;

  const scroller = root.querySelector('[data-related-scroll]');
  const thumb = root.querySelector('[data-related-thumb]');

  const updateScroll = () => {
    if (!scroller || !thumb) return;
    const track = thumb.parentElement;
    if (!track) return;
    const max = scroller.scrollWidth - scroller.clientWidth;
    const thumbWidth = Math.max(
      47,
      Math.round(track.clientWidth * (scroller.clientWidth / Math.max(scroller.scrollWidth, 1)))
    );
    const ratio = max > 0 ? scroller.scrollLeft / max : 0;
    thumb.style.width = `${thumbWidth}px`;
    thumb.style.transform = `translateX(${ratio * (track.clientWidth - thumbWidth)}px)`;
  };

  if (scroller && thumb) {
    scroller.addEventListener('scroll', updateScroll, { passive: true });
    window.addEventListener('resize', updateScroll);
    updateScroll();
  }

  root.querySelectorAll('[data-share-copy]').forEach((button) => {
    button.addEventListener('click', async () => {
      const url = button.getAttribute('data-share-url') || window.location.href;
      const title = document.title;
      try {
        if (navigator.share) {
          await navigator.share({ title, url });
          return;
        }
      } catch (error) {
        if (error && error.name === 'AbortError') return;
      }
      try {
        await navigator.clipboard.writeText(url);
        button.setAttribute('data-copied', 'true');
        window.setTimeout(() => button.removeAttribute('data-copied'), 2000);
      } catch (error) {
        window.prompt(title, url);
      }
    });
  });
})();
